import React, { useEffect, useMemo, useState } from "react";
import { Archive, BarChart3, Boxes, Cloud, CreditCard, IndianRupee, RefreshCcw, ShoppingCart, Truck, Users, Warehouse } from "lucide-react";
import { ReportsService } from "../../../services/reports.service";
import ReportFilters from "./components/ReportFilters";
import OverviewReports from "./OverviewReports";
import UserReports from "./UserReports";
import DriverReports from "./DriverReports";
import ProductReports from "./ProductReports";
import CategoryReports from "./CategoryReports";
import WarehouseReports from "./WarehouseReports";
import MoneyReports from "./MoneyReports";
import OrderReports from "./OrderReports";
import OrderPaymentReports from "./OrderPaymentReports";
import DriverAvailabilityReports from "./DriverAvailabilityReports";
import GoogleUsageReports from "./GoogleUsageReports";
import ArchivedLogsReports from "./ArchivedLogsReports";

const tabs = [
  ["overview", "Overview", BarChart3],
  ["users", "Users", Users],
  ["drivers", "Drivers", Truck],
  ["orders", "Orders", ShoppingCart],
  ["payments", "Payments", CreditCard],
  ["categories", "Category Sales", Boxes],
  ["products", "Products", Boxes],
  ["warehouses", "Warehouses", Warehouse],
  ["money", "Driver Money", IndianRupee],
  ["driverAvailability", "Driver Availability", Truck],
  ["googleUsage", "Google API Usage", Cloud],
  ["dataArchives", "Archived Logs", Archive],
];

export default function ReportsDashboard() {
  const [tab, setTab] = useState("overview");
  const [filters, setFilters] = useState({ period: "month", page: 1, limit: 10 });
  const [dropdowns, setDropdowns] = useState({});
  const params = useMemo(() => filters, [filters]);

  useEffect(() => {
    ReportsService.filters().then((r) => setDropdowns(r.data || {})).catch(() => {});
  }, []);

  return (
    <div className="reports-workspace min-h-screen md:p-7">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-[27px] font-bold text-[#d86a78]">Reports Command Center</h1>
          {!["googleUsage", "dataArchives"].includes(tab) ? <p className="mt-1 text-xs text-slate-800">Category drill-down, customer ranking, product, warehouse, order and money reports.</p> : null}
        </div>
        {!["googleUsage", "dataArchives"].includes(tab) ? (
          <button onClick={() => setFilters((p) => ({ ...p }))} className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#d86a78] px-4 py-3 text-sm font-black text-white shadow-sm transition hover:opacity-90">
            <RefreshCcw size={16} /> Refresh
          </button>
        ) : null}
      </div>

      {!["googleUsage", "dataArchives"].includes(tab) ? <ReportFilters filters={filters} setFilters={setFilters} dropdowns={dropdowns} /> : null}

      <div className="my-5 flex gap-2 overflow-x-auto pb-1">
        {tabs.map(([id, label, Icon]) => (
          <button key={id} onClick={() => setTab(id)} className={`inline-flex shrink-0 items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black transition ${tab === id ? "bg-[#d86a78] text-white shadow-sm" : "border border-[#f4cdd2] bg-white text-slate-500 hover:bg-[#fff8f9]"}`}>
            <Icon size={16} />{label}
          </button>
        ))}
      </div>

      <div className="rounded-[20px] border border-[#f4cdd2] bg-white p-4 shadow-sm md:p-5">
        {tab === "overview" ? <OverviewReports filters={params} /> : null}
        {tab === "users" ? <UserReports filters={params} /> : null}
        {tab === "drivers" ? <DriverReports filters={params} /> : null}
        {tab === "orders" ? <OrderReports /> : null}
        {tab === "payments" ? <OrderPaymentReports filters={params} dropdowns={dropdowns} /> : null}
        {tab === "categories" ? <CategoryReports filters={params} onWarehouseSelect={(warehouseId) => setFilters((p) => ({ ...p, warehouseId: warehouseId || "", page: 1 }))} /> : null}
        {tab === "products" ? <ProductReports filters={params} /> : null}
        {tab === "warehouses" ? <WarehouseReports filters={params} /> : null}
        {tab === "money" ? <MoneyReports filters={params} /> : null}
        {tab === "driverAvailability" ? <DriverAvailabilityReports filters={params} /> : null}
        {tab === "googleUsage" ? <GoogleUsageReports /> : null}
        {tab === "dataArchives" ? <ArchivedLogsReports /> : null}
      </div>
    </div>
  );
}
